module.exports = __webpack_public_path__ + "img/arena-1775.7118cc8e.png";